import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Box, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { useTranslation } from 'react-i18next';
import {ocean} from 'assets/colors';

const Dropzone = ({ onDrop, accept,  id, name, }) => {

  const [t] = useTranslation();
  const [showError, setShowError] = useState({
    show: false,
    message: ''
  })

  const validateFileType = (file) => {
    if (!file.name.includes('.')) {
        setShowError({...showError, show: true, message: `common.components.dragzone.fileExtension` });
        return false;
    }
    const fileType = file.name.split('.')[1];
    const validType = accept.includes(fileType);

    if (!validType) {
      setShowError({...showError, show: true, message: `common.components.dragzone.invalidFormat` });
      return false;
    }

    return true;
  };

  const handleFileRead = (file, callback) => {
    const reader = new FileReader();
    reader.onload = () => {
      const fileContents = reader.result;
      callback(fileContents);
    };
    reader.readAsText(file);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        if (validateFileType(file)) {
          handleFileRead(file, (fileContents) => {
            onDrop(fileContents);
          });
        }
      });
    },
  });

  const message = isDragActive ? (
    <Typography variant="h6" align="center">
      Drop files here ...
    </Typography>
  ) : (
    <Typography variant="h6" align="center">
      <b>Choose a file </b> or drag it here.
    </Typography>
  );

  return (
    <Box
      {...getRootProps()}

      sx={{
        backgroundColor: "#ffffff",
        padding: "5%",
        display: "flex",
        width: '100%',
        minHeight: '200px',
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <input {...getInputProps()} />
      <FileDownloadOutlinedIcon style={{ color: ocean[300], fontSize: 64 }} />
      {message}

      { showError.show &&
        <>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
            <ErrorIcon style={{ color: "red", fontSize: 20 }}/>
            <Typography align="center"
              sx ={{
                fontSize: '0.9em',
                color: "red"
              }}
            >
              {t(showError.message)}
            </Typography>
          </div>
        </>
      }
    </Box>
  );
};

export default Dropzone;
